export type ErrorName =
  | 'AbortError' // JS-native error
  | 'CLEAR_FOCUS_NODES_TIMEOUT'
  | 'CREATE_BILLING_ORGANIZATION_ERROR'
  | 'CREATE_PURSUIT_ERROR'
  | 'CREATE_THREAD_ERROR'
  | 'EXPECTED_STREAM_ERROR'
  | 'FETCH_ERROR'
  | 'MODEL_PROVIDER_ERROR'
  | 'NAVIGATION_ERROR'
  | 'NO_ACCESS_TOKEN_PROVIDED_ERROR'
  | 'NOT_FOUND_ERROR'
  | 'ONBOARDING_ERROR'
  | 'ONEDRIVE_AUTH_ERROR'
  | 'ONEDRIVE_FETCH_ERROR'
  | 'PARSE_STREAMING_ERROR'
  | 'PDF_LOAD_ERROR'
  | 'PURSUIT_NOT_FOUND_ERROR'
  | 'S3_PUT_ERROR'
  | 'SEND_MESSAGE_ERROR'
  | 'SPEECH_RECOGNITION_ERROR'
  | 'START_SHRED_JOB_ERROR'
  | 'TIPTAP_FAILED_TO_SYNC_ERROR'
  | 'UNKNOWN_ERROR'
  | 'UNSUPPORTED_OPERATION'
  | 'UPDATE_ORGANIZATION_ERROR'
  | 'UPLOAD_FILE_ERROR'
  | 'UPDATE_PURSUIT_ERROR'
  | 'EBUY_CREATE_PURSUIT_ERROR'
  | 'EBUY_FETCH_ERROR'
  | 'EBUY_PATCH_ERROR'

export type Cause = {
  status: number
  // Raw backend `detail` string, when present, so callers can branch on a
  // specific error code (e.g. GovWin's personal_govwin_not_connected).
  detail?: string
}

export class SweetspotError extends Error {
  name: ErrorName
  message: string
  cause?: Cause

  constructor({
    name,
    message,
    cause,
  }: {
    name: ErrorName
    message: string
    cause?: Cause
  }) {
    super()
    this.name = name
    this.message = message
    this.cause = cause
  }
}

/** Read backend detail without choosing user-facing fallback copy. */
export const readErrorDetail = async (
  response: Response,
): Promise<string | undefined> => {
  try {
    const body = (await response.json()) as { detail?: unknown }
    return typeof body?.detail === 'string' ? body.detail : undefined
  } catch {
    // Empty or non-JSON responses still carry a useful HTTP status.
    return undefined
  }
}

export const createFetchError = async (
  response: Response,
): Promise<SweetspotError> =>
  new SweetspotError({
    name: 'FETCH_ERROR',
    message: response.statusText,
    cause: {
      status: response.status,
      detail: await readErrorDetail(response),
    },
  })
